import { generateUtilityClass, generateUtilityClasses } from "@suid/base";
export function getCardHeaderUtilityClass(slot) {
    return generateUtilityClass("MuiCardHeader", slot);
}
const cardHeaderClasses = generateUtilityClasses("MuiCardHeader", ["root", "avatar", "action", "content", "title", "subheader"]);
export default cardHeaderClasses;
